// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"InputSearch_searchIcon__K2yQd"};